"use strict";

exports.__esModule = true;
exports.getGTMEventName = exports.getGTMDataLayerName = exports.isGTMEnabled = void 0;

var isGTMEnabled = function isGTMEnabled(options) {
  if (!options || !options.googleTagManagerOptions) {
    return false;
  }

  return true;
};

exports.isGTMEnabled = isGTMEnabled;

var getGTMDataLayerName = function getGTMDataLayerName(options) {
  if (!options || !options.googleTagManagerOptions || !options.googleTagManagerOptions.dataLayerName) {
    return "dataLayer";
  }

  return options.googleTagManagerOptions.dataLayerName;
};

exports.getGTMDataLayerName = getGTMDataLayerName;

var getGTMEventName = function getGTMEventName(options) {
  if (!options || !options.googleTagManagerOptions || !options.googleTagManagerOptions.eventName) {
    return "iubenda_consent_given";
  }

  return options.googleTagManagerOptions.eventName;
};

exports.getGTMEventName = getGTMEventName;


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-iubenda-cookie-footer/utils.js
// module id = 466
// module chunks = 231608221292675